import DM from 'DM';
import replaceNull from '../utils/replace-null.js';
import { getQueryParameters } from '../utils/url.js';

export default class QGraphTracker {
    constructor() {
        this.name = 'qgraph';
        this.hidePrompt();
    }

    hidePrompt() {
        const queryParameters = getQueryParameters()
        if (queryParameters && queryParameters.utm_source === 'qgraph' && queryParameters.utm_medium === 'webpush') {
            const sheet = document.createElement('style');
            const css = '#qgraphFakePromptContainer {display: none;}';
            sheet.appendChild(document.createTextNode(css));
            document.body.appendChild(sheet);
        }
    }

    loadScript() {
        return new Promise((resolve) => {
            if (!window.qg) {
                !function (q, g, r, a, p, h, js) {
                    if (q.qg) return;
                    js = q.qg = function () {
                        js.callmethod ? js.callmethod.call(js, arguments) : js.queue.push(arguments);
                    };
                    js.queue = [];
                    p = g.createElement(r); p.async = !0; p.src = a; h = g.getElementsByTagName(r)[0];
                    h.parentNode.insertBefore(p, h);
                    resolve(q.qg);
                }(window, document, 'script', '//cdn.qgr.ph/qgraph.6105f8c85f2a3badc914.js');

                try {
                    navigator.permissions.query({ name: 'notifications' })
                        .then(function (permission) {
                            permission.onchange = function (event) {
                                var traffic = DM.Utils.getCookie('traffic_source');
                                var permissionStatus = event.currentTarget;

                                if (permissionStatus.state === 'granted' && traffic) {
                                    var data = JSON.parse(traffic);
                                    DM.Utils.trackEvents('notifications', 'granted', data.Name);
                                }
                            };
                        });
                } catch (err) {
                    console.warn('Accessing permissions error:', err);
                }
            } else {
                resolve(window.qg);
            }
        });
    }

    dispatch(event, payload) {
        this.loadScript().then((qgraph) => {
            if (typeof (this[event]) === 'function') {
                this[event](qgraph, payload);
            }
        });
    }

    productsView(qgraph, { qgraphTracking }) {
        if (qgraphTracking && qgraphTracking.category) {

            const params = {
                category: qgraphTracking.category,
                categoryName: qgraphTracking.categoryName,
                color: qgraphTracking.color,
                colorSeo: qgraphTracking.colorSeo,
                firstProductPhotoUrl: qgraphTracking.firstProductIconUrl,
                url: `${qgraphTracking.url}/${qgraphTracking.category}`
            };

            qgraph('event', 'category_entered', replaceNull(params));

            if (qgraphTracking.gender) {
                qgraph('identify', { gender: qgraphTracking.gender });
            }
        }
    }

    productLightboxView(qgraph, {
        productName,
        shopName,
        productId,
        price,
        brandName,
        brandSeo,
        imageUrl,
        category,
        color,
        colorSeo,
        colorUrl,
        shop,
        shopId,
        style,
        styleUrl
    }) {
        if (category) {
            const params = {
                url: `${window.location.origin}/${category.currentCategory}`,
                iconUrl: imageUrl,
                productName,
                shopName,
                productId,
                price,
                brandName,
                category: category.currentCategory,
                categoryName: category.currentCategoryName,
                campaignCategoryUrl: category.broaderCategoryUrl,
                brand: brandSeo,
                color,
                colorSeo,
                colorUrl,
                shop,
                shopId,
                style,
                styleUrl
            };

            qgraph('event', 'clicked_product_lightbox', replaceNull(params));
        }
    }

    seoIndexView(qgraph, payload) {
        qgraph('event', 'seotag_entered', replaceNull(payload));
    }
}
